import type { LearningPlanFeedbackForParents } from '../model/types/learning-plan/interfaces'

import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

const ASSESSMENT_SCORE_MAX = 100

const FEEDBACK_SEPARATOR = '\n\n'

const disciplineLabel: Record<Discipline, string> = {
  [Discipline.Math]: 'math',
  [Discipline.ELA]: 'ela',
}

export const getFeedbackAuthor = (tutorName: string, kidName: string, discipline: Discipline): string => {
  return `— ${tutorName}, ${kidName}'s ${disciplineLabel[discipline]} tutor`
}

export const getAssessmentScoreLabel = (score: number): string => `${score}/${ASSESSMENT_SCORE_MAX}`

export const getFeedbackText = (feedback: LearningPlanFeedbackForParents | null): string | null => {
  if (!feedback) return null

  const text = [feedback.win, feedback.friction, feedback.bud]
    .map(part => part?.trim())
    .filter(Boolean)
    .join(FEEDBACK_SEPARATOR)

  return text || null
}
